var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"property-view pa-10",staticStyle:{"background":"#F2F4F4","height":"100vh"},attrs:{"id":"admin-property-view"}},[_c('v-card',{staticStyle:{"padding":"20px"}},[_c('ExternalBrokerList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }